import { assessmentsHooks } from 'pages/School/Assessments'
import { NormalizerContext } from '../NormalizerContext'
import { useCallback, useContext } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { checkTypes } from 'keys/checkTypes'

const useCustomHeaderItems = () => {
    const { checkType, setCheckType, setLoadingData, methods, assessmentFilters } = useContext(NormalizerContext)

    let headerItems = assessmentsHooks.useHeaderItems()
    const queryClient = useQueryClient()

    const handleChangeCheckType = useCallback((val) => {
        // if (checkType)
        //     queryClient.removeQueries({ queryKey: [checkType.queryKey] })
        setCheckType(val)
        setLoadingData(true)
    }, [checkType])

    let customHeaderItems = [
        headerItems.grade_of_execution,
        headerItems.semester,
        // {
        //     name: "structure",
        //     placeholder: "מבנה מבדק",
        //     component: "autoComplete",
        //     options: [{ id: "SINGLE", name: "בודד" }, { id: "BATTERY", name: "סוללות" }],
        //     input: {
        //         value: assessmentFilters.structure,
        //         onChange: (value) => {
        //             setCheckType({ ...checkType, structure: value })
        //         }
        //     }
        // },
        {
            ...headerItems.category,
            multiple: false,
            focus: true
        },
        {
            name: "checkType",
            options: checkTypes,
            onChange: handleChangeCheckType,
            input: {
                value: checkType,
            },
            placeholder: "תחום הבדיקה",
            border: true,
            width: 110,
            focus: true,
            component: "autoComplete"
        },
        {
            id: 0,
            placeholder: "שיטה",
            options: methods,
            name: "methods",
            component: "autoComplete",
            multiple: true,
            focus: true
        }
    ]

    return customHeaderItems
}

export default useCustomHeaderItems